import Vue from 'vue'
import Router from 'vue-router'
import baseConfig from '@/config/baseConfig'
import util from '@/util/util'

const pathName = baseConfig.compatible.prefix + baseConfig.compatible.module

Vue.use(Router)

let routes = [
	{
		path: '/',
		redirect: {
			path: '/carhome'
		}
	},
	{
		path: '/carhome',
		name: 'carhome',
		alias: pathName + '/carhome',
		component: () => import(/* webpackChunkName: "carHome" */ '@/views1/IndexPage/Index')
	},
	{
		path: '/collection',
		name: 'collection',
		alias: pathName + '/collection',
		component: () => import(/* webpackChunkName: "collection" */ '@/views1/CollectionPage/Index')
	},
	{
		path: '/config-detail',
		name: 'configDetail',
		alias: pathName + '/config-detail',
		component: () =>
			import(/* webpackChunkName: "configDetail" */ '@/views1/ConfigDetailPage/Index')
	},
	{
		path: '/photo-previewer',
		name: 'photoPreviewer',
		alias: pathName + '/photo-previewer',
		component: () =>
			import(/* webpackChunkName: "photoPreviewer" */ '@/views1/PhotoPreviewerPage/Index')
	},
	{
		path: '/detail',
		name: 'detail',
		alias: pathName + '/detail',
		component: () => import(/* webpackChunkName: "detail" */ '@/views1/DetailPage/Index')
	},
	{
		path: '/no-seller',
		name: 'noSeller',
		alias: pathName + '/no-seller',
		component: () => import(/* webpackChunkName: "noSeller" */ '@/views1/NoSellerPage/Index')
	},
	{
		path: '/order-detail',
		name: 'orderDetail',
		alias: pathName + '/order-detail',
		component: () => import(/* webpackChunkName: "orderDetail" */ '@/views1/OrderDetailPage/Index')
	},
	{
		path: '/orderCreator',
		name: 'orderCreator',
		alias: pathName + '/orderCreator',
		component: () =>
			import(/* webpackChunkName: "orderCreator" */ '@/views1/OrderCreatorPage/Index')
	},
	{
		path: '/carOwnerInfo',
		name: 'carOwnerInfo',
		alias: pathName + '/carOwnerInfo',
		component: () =>
			import(/* webpackChunkName: "carOwnerInfo" */ '@/views1/CarOwnerInfoPage/Index')
	},
	{
		path: '/carPurchaseAgreement',
		name: 'carPurchaseAgreement',
		alias: pathName + '/carPurchaseAgreement',
		component: () =>
			import(/* webpackChunkName: "carPurchaseAgreement" */ '@/views1/CarPurchaseAgreement/Index')
	},
	{
		path: '/refund-reason',
		name: 'refundReason',
		alias: pathName + '/refund-reason',
		component: () =>
			import(/* webpackChunkName: "refundReason" */ '@/views1/RefundReasonPage/Index')
	},
	{
		path: '/taskCarOwner',
		name: 'taskCarOwner',
		alias: pathName + '/taskCarOwner',
		component: () =>
			import(/* webpackChunkName: "taskCarOwner" */ '@/views1/TaskCarOwnerPage/Index')
	},
	{
		path: '/quit-reason',
		name: 'quitReason',
		alias: pathName + '/quit-reason',
		component: () => import(/* webpackChunkName: "quitReason" */ '@/views1/QuitReasonPage/Index')
	},
	{
		path: '/pay-result',
		name: 'payResult',
		alias: pathName + '/pay-result',
		component: () => import(/* webpackChunkName: "payResult" */ '@/views1/PayResultPage/Index')
	},
	{
		path: '/orderProtocolList',
		name: 'orderProtocolList',
		alias: pathName + '/orderProtocolList',
		component: () =>
			import(/* webpackChunkName: "orderProtocolList" */ '@/views1/OrderProtocolList/Index')
	},
	{
		path: '/system-busy',
		name: 'systemBusy',
		component: () => import(/* webpackChunkName: "orderProtocolList" */ '@/views1/systemBusy/Index')
	},
	{
		path: '*',
		name: 'error',
		component: () => import(/* webpackChunkName: "error" */ '@/views1/errorPage/Index')
	}
]

// 定义mapping表
export const PID_MAPPING = [
	{
		pattern: /\/carhome\/(.+?)/,
		pid: '/carhome'
	},
	{
		pattern: /\/collection\/(.+?)/,
		pid: '/collection'
	},
	{
		pattern: /\/config-detail\/(.+?)/,
		pid: '/config-detail'
	},
	{
		pattern: /\/photo-previewer\/(.+?)/,
		pid: '/photo-previewer'
	},
	{
		pattern: /\/detail\/(.+?)/,
		pid: '/detail'
	},
	{
		pattern: /\/no-seller\/(.+?)/,
		pid: '/no-seller'
	},
	{
		pattern: /\/orderCreator\/(.+?)/,
		pid: '/orderCreator'
	},
	{
		pattern: /\/carOwnerInfo\/(.+?)/,
		pid: '/carOwnerInfo'
	},
	{
		pattern: /\/carPurchaseAgreement\/(.+?)/,
		pid: '/carPurchaseAgreement'
	},
	{
		pattern: /\/refund-reason\/(.+?)/,
		pid: '/refund-reason'
	},
	{
		pattern: /\/taskCarOwner\/(.+?)/,
		pid: '/taskCarOwner'
	},
	{
		pattern: /\/quit-reason\/(.+?)/,
		pid: '/quit-reason'
	},
	{
		pattern: /\/pay-result\/(.+?)/,
		pid: '/pay-result'
	},
	{
		pattern: /\/orderProtocolList\/(.+?)/,
		pid: '/orderProtocolList'
	}
]

let baseUrl = ''

const envModuleCode = FX_OFFLINEPKG_MODULE_CODE
const envFxBase = FX_BASE

if (envModuleCode) {
	if (location.href.indexOf(envFxBase) > 0) {
		// fx pages公共域名的预览
		baseUrl = `${envFxBase}${baseConfig.compatible.prefix + baseConfig.compatible.module}`
	} else {
		// 业务域名访问
		baseUrl = baseConfig.compatible.prefix + baseConfig.compatible.module
	}
} else {
	// 本地调试或离线包
	baseUrl = ''
}

if (envModuleCode && location.protocol == 'file:') {
	routes.forEach(route => {
		route.alias = baseConfig.compatible.prefix + baseConfig.compatible.module + route.path
	})
}

const router = new Router({
	base: baseUrl,
	mode: util.isOfflinePackage() ? 'hash' : 'history',
	routes: routes
})

export let currentPage = null

router.afterEach(to => {
	Vue.nextTick(() => {
		if (to.matched && to.matched[0].instances.default) {
			currentPage = to.matched[0].instances.default
		}
	})
})

export default router
